import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createStore as createStoreVanilla } from 'zustand';
import { devtools } from 'zustand/middleware';
import { initSendRequest } from './sendRequest';
import { initStoreActions } from './store-actions';
import { getDefaultInitialState } from './store.utils';
// Don't attach the devtools middleware in production, unless a specific URL query-param is provided.
// Otherwise attach, so we can debug the store with the redux-devtools chrome extension.
const disableDevtools = (IS_CYPRESS || IS_PRODUCTION) && !location.search.includes('enableZustandDevtools');
export function createStore(param) {
    let { initialState, session, onLogout, onNoAccess, getNow, initStoreApi, reportToSentry, getCookie, onCookieChange, onAuthTokenInResponse, onAuthTokenRevoked, onBiometricStaleToken, onLogBI } = param;
    const initializer = (setState, getState)=>{
        const { sendRequest, sendStream } = initSendRequest({
            getState,
            onLogout,
            onNoAccess,
            getCookie,
            onCookieChange,
            onAuthTokenInResponse,
            onAuthTokenRevoked,
            onBiometricStaleToken,
            onReportToSentry: (param)=>{
                let { message, fingerprint, requestId, method, url, responseBody, claimsBusinessId, userInfoBusinessId, isSwitchingBusiness } = param;
                return reportToSentry(message, {
                    fingerprint,
                    context: {
                        '** Failed Request Data **': {
                            requestId,
                            method,
                            url,
                            responseBody
                        },
                        '** Identity At Send **': {
                            claimsBusinessId,
                            userInfoBusinessId,
                            isSwitchingBusiness
                        }
                    }
                });
            }
        });
        const api = initStoreApi({
            getState,
            getNow,
            sendRequest,
            sendStream
        });
        const actions = initStoreActions({
            api,
            setState,
            getState,
            onLogBI,
            getNow
        });
        const defaultInitialState = getDefaultInitialState(session);
        return _object_spread_props(_object_spread({}, defaultInitialState, initialState), {
            appConfig: _object_spread({}, defaultInitialState.appConfig, initialState.appConfig),
            actions
        });
    };
    return disableDevtools ? createStoreVanilla(initializer) : createStoreVanilla(devtools(initializer));
}
